import { Component, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MteCheckboxWrapper } from '@mortar/angular/elements/atomic/checkbox';

import { InputComponent } from 'app/driver-pay/persistence/core/components/inputs/InputComponent';

@Component({
  selector: 'boolean-input',
  standalone: true,
  template: ` <mte-checkbox #inputElement id="{{ id() }}" [formControl]="inputFormControl()" /> `,
  imports: [FormsModule, ReactiveFormsModule, MteCheckboxWrapper],
})
export class BooleanInputComponent implements InputComponent {
  inputFormControl = input.required<FormControl<boolean> | FormControl<boolean | null>>();
  id = input.required<string>();
}
